import { useRouter } from 'next/router';
import React, { useEffect, useRef } from 'react';

import s from './AbstractBackground.module.scss';

export default function AbstractBackground(): JSX.Element {
  const router = useRouter();
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    if (canvasRef.current) {
      const canvas = canvasRef.current;
      const ctx = canvas.getContext('2d');

      if (ctx) {
        const dpr = window.devicePixelRatio || 1;
        const rect = canvas.getBoundingClientRect();

        canvas.width = rect.width * dpr;
        canvas.height = rect.height * dpr;

        ctx.scale(dpr, dpr);

        const drawCircle = (
          x: number,
          y: number,
          radius: number,
          color: string,
        ): void => {
          ctx.beginPath();
          ctx.globalAlpha = 0.5;
          ctx.fillStyle = color;

          ctx.arc(x, y, radius, 0, 2 * Math.PI);
          // ctx.filter = 'blur(100px)';

          ctx.fill();
        };

        drawCircle(rect.width, rect.height, 100, '#FF6060');
        drawCircle(rect.width, 100, 30, '#03CB34');
        drawCircle(0, rect.height / 2, 30, '#89A3FF');
      }
    }
  }, []);

  if (router.pathname.includes('/payments')) {
    return <></>;
  }

  return <canvas ref={canvasRef} className={s.canvas} />;
}
